// LoadingSkeleton.js
import "../../css/LoadingSkeleton.css";
const LoadingSkeleton = () => {
  return (
    <>
      <div className="bg-light mt-1 p-4 loading-skeleton">
        <div className="row">
          <div className="col-md-4 ">
            <div className="skeleton-image"></div>
          </div>
          <div className="col-md-8">
            <div className="card-header skeleton-header"></div>
            <div className="">
              <div className="skeleton-text skeleton-title"></div>
              <div className="skeleton-text skeleton-description"></div>
              <ul className="detail-box">
                {[...Array(4)].map((_, index) => (
                  <li key={index} className="skeleton-detail"></li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="card-footer skeleton-footer"></div>
      </div>
    </>
  );
};

export default LoadingSkeleton;
